<app-loader-icon *ngIf="showLoaderIcon && !isTeamSnapshotComponent"></app-loader-icon>
<div *ngIf="!isTeamSnapshotComponent && isUserAuthorized" [ngClass]="notCookieNotice?'completeBody':''" [style.max-width]="windowMinWidth" [style.min-width]="windowMinWidth"
     (window:resize)="onResize($event)">
  <div class="commonHeader row justify-content-md-center" *ngIf="isLoggedin">
    <!--roleId !== 0-->
    <div class="deloitteBlackHeader">
      <div class="row">
        <!-- <div class="logoArea col-6"> -->
        <div [ngClass]="notCookieNotice?'logoArea col-3':'cookieLogoArea'">
          <div class="logo-wrapper">
            <a href="" routerlink="/"><img src="./assets/images/deloitteLogoWhite.png" alt="Deloitte"></a>
            <img *ngIf="notCookieNotice" class="BCLogo" src="./assets/images/BCLogo_small.png" alt="Business Chemistry">
          </div>
        </div>
        <!-- <div class="logoArea col-3">
            <button (click)="gotocookiepolicy();">Cookie Settings</button>
        </div> -->


        <div class="col-6">
          <div class="role-menu-wrapper">
            <!--<app-user-role-list *ngIf="showLeftNavigation" [userRoleDetails]="userRoleList" [selectedRole]="selectedRole" (roleChange)="onRoleChange($event)"></app-user-role-list>-->
            <app-user-role-list *ngIf="showLeftNavigation" (roleChange)="onRoleChange($event)">
            </app-user-role-list>
            <div class="menuIcon_topRight" *ngIf="notCookieNotice">
              <img src="./assets/images/menu_icon.PNG" alt="Menu" #toggleButton
                  (click)="menuIcon()" />
              <!--<button (click)="onHelpClick()" class="btn-black floatRight headerHelpBtn">HELP</button>-->
              <div class="menuDropdown" *ngIf="menuDropdown">
                <ul>
                  <li (click)="openCookieNotice()">Cookies</li>
                  <li class="cookieSettingsLi">
                    <button type="button" class="cookieSettingsBtn" onclick="OneTrust.ToggleInfoDisplay()">Cookie Settings</button>
                  </li>
                  <li (click)="onHelpClick()">Help</li>
                  <li (click)="logout()">Logout</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [ngClass]="notCookieNotice? 'row justify-content-md-center no-gutters greyBgBody pad20 padb0 marB50 mar0':''" *ngIf="isLoggedin">
    <!--roleId !== 0-->
    <div [ngClass]="notCookieNotice?'col-12':''">
      <div [ngClass]="notCookieNotice?'row no-gutters':''">
        <div [ngClass]="notCookieNotice?'col-12':''">
          <div class="leftNavArea Bot35" *ngIf="showLeftNavigation">
            <ul>
              <li [ngClass]=" {'active-tab': tab==1 }" class="subMenu"  [routerLinkActive]="'active-tab'">
                <a [routerLinkActive]="'active-tab'" class="sessionMenu" (click)=" tab =1">
                  <img src="./assets/images/icon_session_.svg" alt="" /><span>Sessions</span>
                  <ul>
                    <li class="verticalMenu" routerLink="/addSession"
                        (click)="tab=2; openConfirmationDialog(); reloadNewSession()">
                      Request a New
                      Session
                    </li>
                    <li class="verticalMenu" routerLink="/searchSession" (click)="tab=2">
                      Search for a
                      Session
                    </li>
                  </ul>
                </a>
              </li>
              <li routerLink="/assessment" [ngClass]=" {'active-tab': tab==2 }"
                  [routerLinkActive]="'active-tab'" (click)=" tab =2">
                <img src="./assets/images/icon_assessment_.svg" alt="" /><span>Assessments</span>
              </li>

              <li routerLink="/facilitatorSearch" [ngClass]=" {'active-tab': tab==3 }"
                  [routerLinkActive]="'active-tab'" (click)=" tab =3">
                <img src="./assets/images/icon_facilitator_.svg" alt="" /><span>
                  Search for a
                  Facilitator
                </span>
              </li>
              <li routerLink="/resources" [ngClass]=" {'active-tab': tab==4}"
                  [routerLinkActive]="'active-tab'" (click)=" tab =4">
                <img src="./assets/images/icon_resources_.svg" alt="" /><span>
                  Resources
                </span>
              </li>
              <li routerLink="/security" *ngIf="roleId === 1 || roleId === 3"
                  [routerLinkActive]="'active-tab'" [ngClass]=" {'active-tab': tab==5 }"
                  (click)=" tab =5">
                <img src="./assets/images/icon_security_.svg" alt="" /><span>Security</span>
              </li>
              <li [ngClass]=" {'active-tab': tab==6 }"
                  class="subMenu" [routerLinkActive]="'active-tab'">
                  <img src="./assets/images/icon_subscriptions_.svg" alt="" /><span>Subscription</span>
                  <ul>
                    <li class="verticalMenu" (click)=" tab =6;reload();" routerLink="/addSubscription"
                        [routerLinkActive]="'active-tab'">Add</li>
                    <li class="verticalMenu" routerLink="/searchSubscription" (click)=" tab =6"
                        [ngClass]="{'disabled': roleId != 1 && roleId != 3 && roleId != 6 }" 
                        [routerLinkActive]="'active-tab'" >Search</li>
                  </ul>
              </li>
              <li *ngIf="roleId === 1 || roleId === 3" [ngClass]=" {'active-tab': tab==7 }" class="subMenu">
                <img src="./assets/images/icon_admin_.svg" alt="" /><span>
                  Administrator
                  Functionalities
                </span>
                <ul class="verticalMenuListWrapper">
                  <li *ngIf="roleId === 1" class="verticalMenu"
                      routerLink="/additionalQuestionsReport" (click)=" tab =7"
                      [routerLinkActive]="'active-tab'">Additional Question Report</li>
                  <li *ngIf="roleId === 1 || roleId === 3" class="verticalMenu"
                      routerLink="/dataCleanup" (click)=" tab =7" [routerLinkActive]="'active-tab'">
                    Data Clean Up
                  </li>
                  <li *ngIf="roleId === 1" class="verticalMenu"
                      routerLink="/manageMailBox" (click)=" tab =7" [routerLinkActive]="'active-tab'">
                    Manage Shared Mailbox
                  </li>
                  <li *ngIf="roleId === 1" class="verticalMenu"
                      routerLink="/searchEmailTemplate" (click)=" tab =7"
                      [routerLinkActive]="'active-tab'">Manage Email Template</li>
                  <li *ngIf="roleId === 1" class="verticalMenu"
                      routerLink="/searchOrganization" (click)=" tab =7"
                      [routerLinkActive]="'active-tab'">Manage Organization</li>
                </ul>
              </li>
            </ul>
          </div>
          <div [ngClass]="notCookieNotice?'mainBody':''">
            <router-outlet (activate)="onActivate($event)"></router-outlet>
          </div>
          <div>
          </div>
        </div>
      </div>
    </div>
  </div>

  
      <div class="modal" id="help_Modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel">
          <div class="help-dialog">
              <div class="modal-dialog helpModalPop" role="document">
                  <div class="modal-content">
                      <div class="helpEditPop">
                          <div class="modal-header">
                              <div class="helpEditPopHeader">
                                  <h5>Help</h5>

                                  <button type="button" class="close">
                                      <span aria-hidden="true" data-bs-dismiss="modal">&times;</span>
                                  </button>
                              </div>
                          </div>
                          <div class="modal-body">
                               <span id="spanhelp" class="help-modal">For support questions, refer to the <a
                                      href="https://amedeloitte.sharepoint.com/sites/DOL-c-US-BizChemHub/Nonfacilitator%20Drive/Forms/AllItems.aspx?id=%2fsites%2fDOL%2Dc%2DUS%2DBizChemHub%2fNonfacilitator%20Drive%2fAdmin%20Portal%20Toolkit%2fbc%2Dadmin%2Dportal%2Dguide%2Epdf&parent=%2fsites%2fDOL%2Dc%2DUS%2DBizChemHub%2fNonfacilitator%20Drive%2fAdmin%20Portal%20Toolkit"
                                      target="_blank">Business Chemistry Admin Portal - User Manual</a> found on
                                  DeloitteResources.</span>
                          </div>
                          <div class="modal-footer">
                              <div class="modal-footerBtns helpPopupFooterArea">
                                  <button type="button" class="clickBtn" data-bs-dismiss="modal">CLOSE</button>


                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

  <app-session-expired></app-session-expired>
  <!--<div class="app_footer">
      Copyright &copy; 2023 Deloitte Development LLC. All rights reserved.
      <a _ngcontent-c2="" class="privacyTextHyperlink" (click)="gotocookiepolicy();">Cookie Settings and Notice</a>-->
  <!-- <a _ngcontent-c2="" class="privacyTextHyperlink" href="https://deloittenet.deloitte.com/system/pages/privacy.aspx" target="_blank">Privacy</a> -->
  <!--</div>-->
</div>

<!-- US: 261189 ==> Confirm with the user that they have the information before making a new session request. ( -->
<div *ngIf="!isTeamSnapshotComponent && isUserAuthorized" class="updateEmail confirmModal">
  <div class="modal" #updateEmail id="mypopup" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
       data-bs-keyboard="false" data-bs-backdrop="static">
    <div class="updateEmail-dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="exampleModalLabel">Confirm</h4>
          </div>
          <div class="modal-body">
            <div>
              <p>
                Before you enter your session request, please make sure you have the
                following:
              </p>
              <ul class="session-confirm-list">
                <li>A confirmed date for your session </li>
                <li>
                  A facilitator who has expressed interest and
                  availability
                </li>
                <li>A WBS or PRD code for the chargeback</li>
              </ul>
              <!-- As per this CR 2694395 removing below line from popup -->
              <!-- <p>If you have not identified a facilitator, you can close this window and
                  click on Search for a Facilitator.</p> -->
              <!-- As per this CR 2705457 adding below new line in popup -->
              <p>
                If these details aren't yet confirmed, you will be prompted to save your request as a
                draft only.
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <!-- As per this CR 2705457 changing both button name Yes==> Continue and No ==> Exit-->
            <button type="button" class="btn btn-default editEmailSaveBtn" data-bs-dismiss="modal"
                    (click)="closeConfirmPopUp()">
              CONTINUE
            </button>
            <!-- As per this CR 2694395 Adding No Button -->
            <button type="button" class="btn btn-default editEmailSaveBtn" data-bs-dismiss="modal"
                    (click)="redirectToFacilitatorSearchPage()">
              EXIT
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-user-unauthorized *ngIf="!isUserAuthorized && !showLoaderIcon && !isTeamSnapshotComponent"></app-user-unauthorized>
<router-outlet *ngIf="isTeamSnapshotComponent"></router-outlet>

<div >
  <input type="button" id="ot-sdk-btn" class="ot-sdk-show-settings" value="Cookie Settings" hidden />
</div>
